import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingSpinnerProps {
  height?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ height = '200px' }) => {
  return (
    <Box mt={3.75}>
      <Box display="flex" justifyContent="center" alignItems="center" height={height}>
        <CircularProgress />
      </Box>
    </Box>
  );
};
